<template>
    <Modal
            v-model="_value"
            width="500"
            title="RM关闭SIM卡锁"
            @on-visible-change="visibleChange"
            ok-text="关闭"
            cancel-text="">
        <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">

<!--            <Button type="primary" @click="onCleanDriverCardParams" style="margin-right: 5px;">清空</Button>-->
            <Button type="primary" @click="onSendDriverCardParams">发送</Button>
        </Form>
    </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'rmsetclosesimlockmodal',
  components: {},
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {

    }
  },
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    visibleChange (val) {
      if (val) {

      }
    },

    onSendDriverCardParams () {
      this.SendCommand('99admin,beUL42,SHBC0!')

      //粤T07440-2025-04-08 19:27:39
      //粤R56415-2025-04-10 17:54:13
      setTimeout(() => {
          this.SendCommand('99admin,718293,SHBC0!')
        }
        , 500)

      //粤T62993-2025-04-12 11:32:30
      setTimeout(() => {
          this.SendCommand('99admin,827516,SHBC0!')
        }
        , 1000)

      //粤T60167-2025-04-15 08:36:19
      setTimeout(() => {
          this.SendCommand('99admin,712243,SHBC0!')
        }
        , 1500)

      //粤T93933-2025-04-15 09:02:46
      setTimeout(() => {
          this.SendCommand('99admin,418446,SHBC0!')
        }
        , 2000)

      //粤T59770-2025-04-14 11:52:51
      setTimeout(() => {
          this.SendCommand('99admin,797638,SHBC0!')
        }
        , 2500)

      //粤T59965-2025-04-14 09:28:20
      setTimeout(() => {
          this.SendCommand('99admin,110666,SHBC0!')
        }
        , 3000)

        //粤T63043-2025-04-15 08:41:39
      setTimeout(() => {
          this.SendCommand('99admin,385949,SHBC0!')
        }
        , 3500)

      //粤T58212-2025-05-15 13:07:59
      setTimeout(() => {
          this.SendCommand('99admin,390191,SHBC0!')
        }
        , 4000)

      setTimeout(() => {
          this.SendCommand('99admin,775717,SHBC0!')
        }
        , 4500)

      setTimeout(() => {
          this.SendCommand('99admin,123456,SHBC0!')
        }
        , 5000)
    },
    SendCommand (content) {
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: false }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
